var React = require('react');

function Heart16x16 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=16x16, Invert=off"},React.createElement("path",{"id":"Vector","d":"M13.447 2.766c.439.317.804.73 1.07 1.21a3.864 3.864 0 01.251 3.184 3.775 3.775 0 01-.866 1.372l-5.02 5.045a1.365 1.365 0 01-1.981 0L2.126 8.532a3.958 3.958 0 01-.476-4.937c.309-.452.71-.827 1.176-1.1A3.559 3.559 0 015.92 2.24a3.63 3.63 0 011.332.893l.763.793.7-.67a3.677 3.677 0 014.733-.49v0z","stroke":"currentColor","strokeMiterlimit":"10"})));
}

Heart16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Heart16x16;

Heart16x16.default = Heart16x16;
